import { ArrowPathIcon } from '@heroicons/react/24/outline';
import { cn } from '@/shared/lib/utils';

export const Spinner = ({ className, ...props }: React.ComponentProps<'svg'>) => {
  return (
    <ArrowPathIcon
      role="status"
      aria-label="Loading"
      className={cn('size-4 animate-spin text-gray-300', className)}
      {...props}
    />
  );
};
